import { render } from "./GrVerification.vue?vue&type=template&id=73a59137&scoped=true"
import script from "./GrVerification.vue?vue&type=script&lang=js"
export * from "./GrVerification.vue?vue&type=script&lang=js"

import "./GrVerification.vue?vue&type=style&index=0&id=73a59137&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73a59137"]])

export default __exports__